import { useCallback, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import { Button, List } from 'yoso';
import { TransactionType, useDonHistories } from '~/components/Don/History/DonHistory.hooks';
import { DonHistoryListItem } from '~/components/Don/History/List/DonHistoryListItem';

export type DonHistoryListProps = {
  transactionType: TransactionType;
  className?: string;
};
export const DonHistoryList = ({ transactionType, className }: DonHistoryListProps) => {
  const { fetchNextPage, hasNextPage, data } = useDonHistories(
    { transactionType },
    { keepPreviousData: true }
  );
  const onInViewChange = useCallback(
    (inView) => {
      if (inView) {
        fetchNextPage();
      }
    },
    [fetchNextPage]
  );
  const { ref } = useInView({ onChange: onInViewChange, rootMargin: '50% 0px' });
  const onListButtonClick = useCallback(() => fetchNextPage(), [fetchNextPage]);

  const items = useMemo(
    () => data?.pages.map(({ transactionList }) => transactionList).flat() || [],
    [data]
  );
  return (
    <List className={className}>
      {items.map((item) => (
        <li key={item.id}>
          <DonHistoryListItem {...item} />
        </li>
      ))}
      {hasNextPage && (
        <li ref={ref}>
          <Button className="don-history_fetch_more_button" onClick={onListButtonClick}>
            See more
          </Button>
        </li>
      )}
    </List>
  );
};
